import React, { useState } from "react";
import ButtonVitec from "../../../app/components/ButtonHighlight";
import Typography from "@mui/material/Typography";
import Tooltip from "@mui/material/Tooltip";
import InfoIcon from "@mui/icons-material/Info";
import { Box } from "@mui/material";

interface HeaderProps {
  onFetchTransactions: () => void;
  onFetchSalg: () => void;
  onFetchKundeTopp50: () => void;
  onhandleExport: () => void;
  isExportDisabled: boolean;
  onReset: () => void;
}

const Header = ({ onFetchTransactions, onFetchSalg, onFetchKundeTopp50, onhandleExport, isExportDisabled, onReset }: HeaderProps) => {
  const [activeButton, setActiveButton] = useState<string | null>(null);

  const handleButtonClick = (buttonType: string) => {
    setActiveButton(buttonType);
    if (buttonType === "transactions") {
      onFetchTransactions();
    } else if (buttonType === "salg") {
      onFetchSalg();
    } else if (buttonType === "kundeTopp50") {
      onFetchKundeTopp50();
    }else if (buttonType === "export") {
      onhandleExport();
    }
  };

  const tooltipContent = (
    <Box>
      {/* Section 1 */}
      <Box sx={{  padding: "5px", fontWeight: "bold" }}>
        Alle transaksjoner
      </Box>
      <Typography variant="body2" sx={{ padding: "5px" }}>
        Tast inn alfa og artikkel og klikk på "Alle Transaksjoner". Kan ikke kombineres med kundenummer.
Programmet liste ut de siste 2000 transaksjonene på denne varen pr. side.
Trykk "neste side" nederst i tabell for de neste 2000 transaksjonene. Ved eksport til Excel får du alle transaksjonene pr. side du er på.
I tabellen kan du søke ved hjelp av filter i de ulike feltene. I alle felt søker du på innholdet i feltet.

      </Typography>
      <hr />
      {/* Section 2 */}
      <Box sx={{  padding: "5px", fontWeight: "bold" }}>
        Salg siste 4 år
      </Box>
      <Typography variant="body2" sx={{ padding: "5px" }}>
        Tast inn alfa og artikkel og klikk på «Salg siste 4 år». Programmet viser salg pr. mnd. i antall og beløp for de siste 4 år.
      </Typography>
      <hr />
      {/* Section 3 */}
      <Box sx={{ padding: "5px", fontWeight: "bold" }}>
        Kunde Topp 100
      </Box>
      <Typography variant="body2" sx={{ padding: "5px" }}>
        Tast inn kundenummer og klikk «Kunde Topp 100». Viser automatisk totalt i år. Mulighet for å få salg i fjor, alene eller totalt med salg hittil i år ved å sette hake på begge år. Det kan også settes inn varegruppe for kundens kjøp i denne varegruppen. Husk å klikk på «Kunde Topp 100» ved endring av år eller varegruppe.
      </Typography>
    </Box>
  );
  return (
    <Box sx={{ mb: 2.5 }}>
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 1 }}>
           {/* Button for "Alle transaksjoner" */}
      <ButtonVitec
        _type="submit"
        _fontsize="1em"
        _onclick={() => handleButtonClick("transactions")}
        _label="Alle transaksjoner"
        _width={220}
        _height={40}
        _padding={5}
        _margin={0}
        highlighted={activeButton === "transactions"} // Check if this button is active
      />

      {/* Button for "Salg siste 4 år" */}
      <ButtonVitec
        _type="submit"
        _fontsize="1em"
        _onclick={() => handleButtonClick("salg")}
        _label="Salg siste 4 år"
        _width={220}
        _height={40}
        _padding={5}
        _margin={0}
        highlighted={activeButton === "salg"} // Check if this button is active
      />

      {/* Button for "Kunde Topp 100" */}
      <ButtonVitec
        _type="submit"
        _fontsize="1em"
        _onclick={() => handleButtonClick("kundeTopp50")}
        _label="Kunde Topp 100"
        _width={220}
        _height={40}
        _padding={5}
        _margin={0}
        highlighted={activeButton === "kundeTopp50"} // Check if this button is active
      />
      {/* Button for "Excel" */}
       <ButtonVitec
        _type="button"
        _label="Excel"
        _onclick={() => handleButtonClick("export")}
        _fontsize="1em"
        _width={220}
        _height={40}
        _padding={5}
        _margin={0}
        disabled={isExportDisabled}
         _backgroundColor="#1d6f42"
      />
      <ButtonVitec
        _type="button"
        _label="Nullstill"
        _onclick={onReset}
        _fontsize="1em"
        _width={130}
        _height={40}
        _padding={5}
        _margin={0}
      />

      {/* Info Tooltip */}
      <Box sx={{ height: 40, display: "inline-flex", alignItems: "center" }}>
        <Tooltip title={<Typography variant="body2">{tooltipContent}</Typography>} arrow>
          <InfoIcon style={{ cursor: "pointer", color: "#1d6f42" }} />
        </Tooltip>
      </Box>
      </Box>
    </Box>
  );
};

export default Header;
